import {
  CreateButton,
  DeleteButton,
  List,
  SaveButton,
  TextField,
  getDefaultSortOrder,
  useTable,
} from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import {
  Button,
  Col,
  Divider,
  Form,
  FormProps,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tag,
} from "antd";
import type { ColumnsType } from "antd/es/table";

import {
  CrudFilters,
  IResourceComponentsProps,
  getDefaultFilter,
  useModal,
  useGetIdentity,
} from "@refinedev/core";

import { IDigitalPublication, INavWarnings } from "interfaces";
import React from "react";
import { DeleteFiles } from "./components/delete-files";
import { RoleEnum } from "types/roles";

export const NavWarningsList: React.FC<IResourceComponentsProps> = () => {
  const [record, setRecord] = React.useState<INavWarnings>();
  const { data: identity } = useGetIdentity();
  const isDistributorAdmin = identity?.role === RoleEnum.DistributorAdmin || identity?.role === RoleEnum.DistributorSuperAdmin;

  const { tableProps, sorters, tableQuery: { isLoading }, searchFormProps, filters } =
    useTable<INavWarnings>({
      resource: "nav-warnings",
      syncWithLocation: false,

      onSearch: (params: any) => {
        const filters: CrudFilters = [];
        const { title } = params;

        filters.push({
          field: "title",
          operator: "contains",
          value: title ? title : undefined,
        });

        return filters;
      },

      sorters: {
        initial: [
          {
            field: "id",
            order: "desc",
          },
        ]
      }
    });
  const { show, visible, close } = useModal();

  const columns: ColumnsType<INavWarnings> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 600,
      className: "wrap-text",
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("title", sorters),
      sorter: true,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            icon={<Icons.DownloadOutlined />}
            href={record?.storageUrl}
            download={true}
          />
          <Button
            size="small"
            icon={<Icons.FilePdfOutlined />}
            download={false}
            onClick={() => {
              setRecord(record);
              show();
            }}
          />
          <DeleteButton
            hideText
            size="small"
            recordItemId={record.id}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <List
        breadcrumb={false}
        headerProps={{
          // onBack: () => window.history.back(),
          title: "Digital Bookshelf",
          subTitle: "worldwide navigational warnings",
          tags: isLoading ? (
            <Tag color="orange">loading</Tag>
          ) : (
            <Tag color="green">live</Tag>
          ),
          extra: (
            <React.Fragment>
              <Space>
                <CreateButton />
                {isDistributorAdmin && <DeleteFiles />}
              </Space>
            </React.Fragment>
          ),
          ghost: true,
          footer: (
            <Divider plain>
              © {new Date().getFullYear()} e-Mariner NavSolutions
            </Divider>
          ),
        }}
      >
        <Row gutter={[16, 16]}>
          {/* <Col xl={24} lg={24} xs={24}>
            <Card type="inner" title={"Filter"}>
              <Filter formProps={searchFormProps} filters={filters || []} />
            </Card>
          </Col> */}
          <Col xl={24} xs={24}>
            <Table
              {...tableProps}
              columns={columns}
              rowKey="id"
              size="middle"
              scroll={{ x: 1200 }}
              sticky
              pagination={{
                ...tableProps.pagination,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              }}
            />
          </Col>
        </Row>
      </List>
      <Modal
        centered
        closeIcon={<Icons.CloseSquareFilled />}
        visible={visible}
        onCancel={close}
        width="80%"
        footer={null}
      >
        <div>
          <embed
            src={record?.embedUrl}
            type="application/pdf"
            width="99%"
            height="700px"
          />
        </div>
      </Modal>
    </>
  );
};

const Filter: React.FC<{ formProps: FormProps; filters: CrudFilters }> = (
  props
) => {
  const { formProps, filters } = props;

  return (
    <Form
      layout="vertical"
      {...formProps}
      initialValues={{
        title: getDefaultFilter("title", filters),
      }}
    >
      <Row gutter={[10, 0]} align="bottom">
        <Col xl={12} md={8} sm={12} xs={24}>
          <Form.Item label={"Title"} name="title">
            <Input placeholder="filter by title" allowClear />
          </Form.Item>
        </Col>
        <Col xl={24} md={8} sm={12} xs={24}>
          <Form.Item
            style={{
              margin: "auto",
              width: "25%",
            }}
          >
            <SaveButton onClick={formProps.form?.submit} size="large" block>
              Filter
            </SaveButton>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
